import React from "react";
import {
  popupNavigation,
} from "../../util/functions/UniversalFunctions";
import { useNavigate } from "react-router-dom";
import { EventData } from "../../types/eventType";

type ViewEventPopupProps = {
  event: EventData;
  onClose: () => void;
  dropdownRef: React.RefObject<HTMLDivElement>;
  position: {
    top: number;
    left: number;
  };
};

export default function ViewEventPopup({
  event,
  onClose,
  dropdownRef,
  position,
}: ViewEventPopupProps) {
  const navigate = useNavigate();
  const hoverTimeout = React.useRef<number | null>(null);

  const formatDateTime = () => {
    const date = new Date(
      `${event.startDate}T${event.startTime || "00:00:00"}`,
    );

    return date.toLocaleString("default", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 pointer-events-none">
      <div
        ref={dropdownRef}
        onMouseEnter={() => {
          if (hoverTimeout.current) {
            clearTimeout(hoverTimeout.current);
            hoverTimeout.current = null;
          }
        }}
        onMouseLeave={() => {
          hoverTimeout.current = window.setTimeout(() => {
            onClose();
          }, 150);
        }}
        style={{
          top: position.top,
          left: position.left,
        }}
        className="fixed z-50 pointer-events-auto bg-white rounded-xl shadow-lg w-72 p-4 flex flex-col gap-2"
      >
        <div className="w-full h-44 rounded-lg bg-gradient-to-r from-primary-500 to-indigo-500 flex items-center justify-center text-white font-semibold text-lg shadow-md">
          {event.occasionType}
        </div>

        <h3 className="text-base font-semibold capitalize text-neutral-400 mt-2">
          {event.title}
        </h3>

        <p className="text-sm text-neutral-300 tracking-[-0.05px] line-clamp-2">
          {event.description || "No description provided."}
        </p>

        <p className="text-error-600 text-sm font-semibold">
          {formatDateTime()}
        </p>

        <button
          onClick={() => {
            if (hoverTimeout.current) {
              clearTimeout(hoverTimeout.current);
            }
            onClose();
            navigate(popupNavigation("createEvent"), {
              state: {
                mode: "edit",
                event,
              },
            });
          }}
          className="py-2 text-sm rounded underline text-primary-500 text-start"
        >
          View Event
        </button>
      </div>
    </div>
  );
}
